import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom';
import React from 'react';

export function withRouterV6(Component: React.ComponentType<any>) {
  const Wrapper = (props: any) => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    return (
      <Component
        {...props}
        navigate={navigate}
        params={params}
        location={location}
        searchParams={searchParams}
      />
    );
  };

  return Wrapper;
}

export function connectWithRouter(mapStateToProps?: any, mapDispatchToProps?: any) {
  return (Component: React.ComponentType<any>) => {
    const WrappedComponent = withRouterV6(Component);
    return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
  };
}